export const COLORS = {
  BACKGROUND: '#FDFCFB',
  SURFACE: '#FFFFFF',
  BORDER: '#E2D1C3',
  
  PRIMARY: {
    50: '#FDFCFB',
    100: '#F5F5F4',
    200: '#E2D1C3',
    300: '#D7CCC8',
    400: '#A1887F',
    500: '#8D6E63',
    600: '#5D4037',
    700: '#4B2C20',
    800: '#3E2723',
    900: '#2A1B18',
  },
  
  ACCENT: {
    GOLD: '#D4AF37',
    SAGE: '#818C78',
  },

  STATUS: {
    SUCCESS: '#2D6A4F',
    ERROR: '#9B2226',
    WARNING: '#B07D05',
    INFO: '#457B9D',
  }
};

// 2. Subscription Plans
export const SUBSCRIPTION_PLANS = {
  FREE: 'free',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  SEMESTER: 'semester'
};

// Updated FEATURES to include all plan types
const PREMIUM_FEATURES = {
  DAILY_UPLOADS: 999999,
  SUMMARY_LENGTH: 'Extended (Detailed)',
  PDF_EXPORT: true,
  QUIZ_GENERATION: true,
  AI_MODEL: 'GPT-4o (High Precision)',
};

export const FEATURES = {
  [SUBSCRIPTION_PLANS.FREE]: {
    DAILY_UPLOADS: 3,
    SUMMARY_LENGTH: '150-250 words',
    PDF_EXPORT: false,
    QUIZ_GENERATION: false,
    AI_MODEL: 'GPT-4o-mini',
  },
  [SUBSCRIPTION_PLANS.WEEKLY]: PREMIUM_FEATURES,
  [SUBSCRIPTION_PLANS.MONTHLY]: PREMIUM_FEATURES,
  [SUBSCRIPTION_PLANS.SEMESTER]: PREMIUM_FEATURES,
};

// 3. Document & File Settings
export const PROCESSING_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed'
};

export const FILE_VALIDATION = {
  MAX_FILE_SIZE: 5 * 1024 * 1024,
  SUPPORTED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.webp'],
};

export const UPLOAD_LIMITS = FILE_VALIDATION;

// 4. Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  UPLOAD: '/upload',
  PRICING: '/pricing',
  HISTORY: '/history',
  PAST_QUESTIONS: '/past-questions',
  DOCUMENT: '/document/:id',
  SETTINGS: '/settings',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  HOW_IT_WORKS: '/how-it-works',
};

// 5. System Messages
export const ERROR_MESSAGES = {
  NETWORK: 'Connection error. Check your data or Wi-Fi.',
  AUTH_FAILED: 'Invalid login details. Please try again.',
  UPLOAD_FAILED: 'Could not upload. Check the file format.',
  PROCESSING_FAILED: 'AI had trouble reading this page. Try a clearer photo.',
  LIMIT_REACHED: 'You have used your 3 free daily uploads. Upgrade to Premium for unlimited access!',
  FILE_TOO_LARGE: 'This image is too heavy. Keep it under 5MB.',
  INVALID_FILE_TYPE: 'Invalid file type. Please upload JPG, PNG, or WEBP images.',
  GENERIC: 'Something went wrong. Refresh the page.',
};

export const SUCCESS_MESSAGES = {
  LOGIN: 'Welcome back to OmniClarix!',
  SIGNUP: 'Welcome aboard! Your academic journey just got easier.',
  LOGOUT: 'Logged out successfully',
  UPLOAD_SUCCESS: 'Page uploaded! Processing started...',
  PROCESSING_COMPLETE: 'Simplification complete!',
  PASSWORD_RESET_SENT: 'Check your email for reset instructions.',
  PASSWORD_RESET_SUCCESS: 'Password reset successfully!',
  PROFILE_UPDATED: 'Profile updated successfully!',
  SUBSCRIPTION_UPGRADED: 'Upgraded to Premium successfully!',
};

// 6. Pricing & Paystack
export const PRICING = {
  WEEKLY: 1000,
  MONTHLY: 3000,
  SEMESTER: 10000,
};

export const PLAN_DURATION = {
  WEEKLY: 7,
  MONTHLY: 30,
  SEMESTER: 120,
};

export const PAYSTACK = {
  // Use VITE_ prefix if using Vite, otherwise keep REACT_APP_
  PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || '', 
  CURRENCY: 'NGN',
  CHANNELS: ['card', 'bank', 'ussd', 'qr', 'mobile_money', 'bank_transfer'],
};

export const PLAN_DETAILS = {
  WEEKLY: {
    name: 'Weekly',
    price: PRICING.WEEKLY,
    duration: PLAN_DURATION.WEEKLY,
    description: 'Perfect for short-term exam prep',
    popular: false,
    savings: null,
  },
  MONTHLY: {
    name: 'Monthly',
    price: PRICING.MONTHLY,
    duration: PLAN_DURATION.MONTHLY,
    description: 'Best for regular students',
    popular: true,
    savings: 'Save ₦1,000',
  },
  SEMESTER: {
    name: 'Semester',
    price: PRICING.SEMESTER,
    duration: PLAN_DURATION.SEMESTER,
    description: 'Best value for serious students',
    popular: false,
    savings: 'Save ₦2,000',
  },
};

// 7. UI & Storage
export const UI = {
  TOAST_DURATION: 4000,
  SPLASH_SCREEN_DURATION: 2500,
  ANIMATION_SPEED: 0.3,
};

export const STORAGE_KEYS = {
  AUTH_SESSION: 'omniclarix_session',
  THEME_PREFERENCE: 'omniclarix_theme',
};

export const AI_CONFIG = {
  SYSTEM_INSTRUCTION: "You are an academic assistant that simplifies textbook content for polytechnic and university students in Nigeria. Use simple language, clear structures, and relate concepts to local examples where possible.",
  SUMMARY_WORD_COUNT: "150-250 words",
};

const constants = {
  COLORS,
  SUBSCRIPTION_PLANS,
  FEATURES,
  PROCESSING_STATUS,
  UPLOAD_LIMITS,
  FILE_VALIDATION,
  ROUTES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  PRICING,
  UI,
  STORAGE_KEYS,
  AI_CONFIG
};

export default constants;